import styled from "styled-components";
const Button = styled.button`
height: 3rem;
margin: 2rem 2.5%;
padding: 0 1rem;
width: 30%;
background: linear-gradient(
  90deg,
  rgba(238, 109, 152, 1) 15%,
  rgba(138, 94, 191, 1) 85%
);
color: #fff;
outline: none;
border: none;
border-radius: 7.5px;
position: absolute;
transform: translateX(-100%);
cursor: pointer;
`;
export default Button;